import CalendarView from '@/components/calendar/CalendarView'
import { createFileRoute } from '@tanstack/react-router'
import { type } from 'arktype'

export const Route = createFileRoute('/dashboard/admin/events/')({
  component: RouteComponent,
  validateSearch: type({
    // view: type.enumerated(['month', 'year']),
    view: 'string = "month"',
    //     defaultValue: format(new Date(currentDate.getFullYear(), 0, 1), 'yyyy-MM-dd'),
    // // TODO: this Date | string thing is kinda a hack so check it
    // startDate: type('Date | string').default(() => new Date(new Date().getFullYear(), 0, 1)),
    // endDate: type('Date | string').default(() => new Date(new Date().getFullYear(), 11, 31)),
  }),
})

function RouteComponent() {
  const { view } = Route.useSearch()

  return <CalendarView view={view} />
}
